<!--begin::Info-->
<div
  ngbDropdown
  [container]="'body'"
  #myDrop="ngbDropdown"
  (openChange)="onDropdownEvent($event)"
  class="my-0"
>
  <div type="button" ngbDropdownToggle>
    <ng-content></ng-content>
  </div>

  <!--begin::Menu 2-->
  <div
    class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px py-4"
    ngbDropdownMenu
    data-kt-menu="true"
  >
    <ng-container *ngFor="let item of dropdownItems">
      <ng-container *ngIf="!item?.forceHide">
        <div
          *ngIf="!!item"
          NgbDropdownItem
          [ngxTippy]="item.disabled ? 'Coming Soon' : null"
          (click)="myDrop.close()"
          class="menu-item px-3"
        >
          <a
            *ngIf="item.href"
            [attr.href]="item.href"
            [attr.target]="item.target ? item.target : null"
            (click)="item.action ? item.action() : null"
            [ngClass]="{ 'fake-disabled opacity-50': item.disabled }"
            class="menu-link text-{{ item.colorSet }} text-hover-{{
              item.colorSetHover || item.colorSet
            }} bg-hover-light-{{ item.colorSetHover || item.colorSet }} px-3"
          >
            <svg-icon
              *ngIf="!!item?.iconSvg && !item?.iconLabel"
              [src]="item.iconSvg"
              class="svg-icon svg-icon-2 me-2 text-{{ item.colorSet }}"
            ></svg-icon>
            <i
              *ngIf="!!item?.iconLabel"
              class="ki-duotone ki-{{item.iconLabel}} fs-2 me-2 text-{{ item.colorSet }}"
            >
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
              <span class="path4"></span>
              <span class="path5"></span>
              <span class="path6"></span>
            </i>

            {{ item.label }}
          </a>
          <a
            *ngIf="!item?.href"
            [routerLink]="item.routerLink"
            (click)="item.action ? item.action() : null"
            [ngClass]="{ 'fake-disabled opacity-50': item.disabled }"
            class="menu-link text-{{ item.colorSet }} text-hover-{{
              item.colorSetHover || item.colorSet
            }} bg-hover-light-{{ item.colorSetHover || item.colorSet }} px-3"
          >
          <svg-icon
          *ngIf="!!item?.iconSvg && !item?.iconLabel"
          [src]="item.iconSvg"
          class="svg-icon svg-icon-2 me-2 text-{{ item.colorSet }}"
        ></svg-icon>
        <i
          *ngIf="!!item?.iconLabel"
          class="ki-duotone ki-{{item.iconLabel}} fs-2 me-2 text-{{ item.colorSet }}"
        >
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
          <span class="path5"></span>
          <span class="path6"></span>
        </i>
            {{ item.label }}
          </a>
        </div>

        <div *ngIf="!item" class="separator my-3 opacity-75"></div>
      </ng-container>
    </ng-container>
  </div>
  <!--end::Menu 2-->
</div>
<!--end::Info-->
